document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('.rich-text__buttons a');
  const panels = document.querySelectorAll('.panel-content');
  const icons = document.querySelectorAll('.tabbed-multicolumn');
  const forms = document.querySelectorAll('.tabbed-form');
  const collapsibles = document.querySelectorAll('.tabbed-collapsible');

  buttons.forEach(button => {
    button.addEventListener('click', function () {
      console.log(icons);
      // Remove 'active' class from all panels
      panels.forEach(panel => panel.classList.remove('active'));
      buttons.forEach(btn => btn.classList.remove('active'));
      icons.forEach(icon => icon.classList.remove('active'));
      forms.forEach(icon => icon.classList.remove('active'));
      collapsibles.forEach(icon => icon.classList.remove('active'));

      // Get the target panel's ID from the data attribute
      const targetPanel = this.getAttribute('data-panel-id');

      console.log(targetPanel);

      // Find the panel with the matching data-content-id and add 'active' class
      const panelToShow = document.querySelector(`.panel-content[data-content-id="${targetPanel}"]`);
      const iconsToShow = document.querySelector(`.multicolumn[data-icons-id="${targetPanel}"]`);
      const formsToShow = document.querySelector(`.tabbed-form[data-form-panel-id="${targetPanel}"]`);
      const collapsiblesToShow = document.querySelector(`.tabbed-collapsible[data-collapsible-panel-id="${targetPanel}"]`);
      if (panelToShow) {
        panelToShow.classList.add('active');
      }
      if (iconsToShow) {
        iconsToShow.classList.add('active');
      }
      if (formsToShow) {
        formsToShow.classList.add('active');
      }
      if (collapsiblesToShow) {
        collapsiblesToShow.classList.add('active');
      }
      this.classList.add('active');
    });
  });

});

document.body.matchHeight({elements: '.card__caption-star-caption'});
